<template>
  <div class="app-settings-page">
    <Tabs value="ios" @on-click="showName">
      <TabPane label="iOS版本更新设置" name="ios">
        <Form
          ref="ios"
          :rules="versionRule"
          :label-width="150"
          :model="ios"
          style="width: 550px"
        >
          <FormItem prop="version_name" label="版本号">
            <Input placeholder="版本号" v-model="ios.version_name" clearable />
          </FormItem>
          <FormItem prop="version_code" label="版本代码">
            <Input
              placeholder="版本代码"
              v-model="ios.version_code"
              clearable
            />
          </FormItem>
          <FormItem prop="version_detail" label="更新详情">
            <Input
              type="textarea"
              placeholder="更新详情"
              v-model="ios.version_detail"
              clearable
            />
          </FormItem>
          <FormItem prop="download_url" label="下载地址">
            <Input
              type="textarea"
              placeholder="下载地址"
              v-model="ios.download_url"
              clearable
            />
          </FormItem>
          <FormItem prop="is_force_update" label="是否强制更新">
            <Checkbox v-model="ios.is_force_update">
              <span v-if="ios.is_force_update">是</span>
              <span v-if="!ios.is_force_update">否</span>
            </Checkbox>
          </FormItem>
        </Form>
        <div style="text-align: right">
          <Button
            size="large"
            type="primary"
            style="margin: 0 15px"
            @click="submits('ios')"
          >
            提交
          </Button>
          <Button size="large" @click="reset('ios')">重置</Button>
        </div>
      </TabPane>
      <TabPane label="Android版本更新设置" name="android">
        <Form
          ref="android"
          :rules="versionRule"
          :label-width="150"
          :model="android"
          style="width: 550px"
        >
          <FormItem prop="version_name" label="版本号">
            <Input
              placeholder="版本号"
              v-model="android.version_name"
              clearable
            />
          </FormItem>
          <FormItem prop="version_code" label="版本代码">
            <Input
              placeholder="版本代码"
              v-model="android.version_code"
              clearable
            />
          </FormItem>
          <FormItem prop="version_detail" label="更新详情">
            <Input
              type="textarea"
              placeholder="更新详情"
              v-model="android.version_detail"
              clearable
            />
          </FormItem>
          <FormItem prop="download_url" label="下载地址">
            <Input
              type="textarea"
              placeholder="下载地址"
              v-model="android.download_url"
              clearable
            />
          </FormItem>
          <FormItem prop="is_force_update" label="是否强制更新">
            <Checkbox v-model="android.is_force_update">
              <span v-if="android.is_force_update">是</span>
              <span v-if="!android.is_force_update">否</span>
            </Checkbox>
          </FormItem>
        </Form>
        <div style="text-align: right">
          <Button
            size="large"
            type="primary"
            style="margin: 0 15px"
            @click="submits('android')"
          >
            提交
          </Button>
          <Button size="large" @click="reset('android')">重置</Button>
        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
const buildConfig = require("../../../build/" + process.env.BUILD_ENV + ".js");
export default {
  name: "AppSettings",
  data() {
    return {
      initialData: {
        version_name: "",
        version_code: "",
        version_detail: "",
        download_url: "",
        type: "",
        is_force_update: false,
      },
      ios: {
        version_name: "",
        version_code: "",
        version_detail: "",
        download_url: "",
        type: "ios",
        is_force_update: false,
      },
      versionRule: {
        version_name: [
          { required: true, message: "版本号不能为空", trigger: "blur" },
        ],
        version_code: [
          { required: true, message: "版本代码不能为空", trigger: "blur" },
        ],
        version_detail: [
          { required: true, message: "版本详情不能为空", trigger: "blur" },
        ],
        download_url: [
          { required: true, message: "下载地址不能为空", trigger: "blur" },
        ],
      },
      android: {
        version_name: "",
        version_code: "",
        version_detail: "",
        download_url: "",
        type: "android",
        is_force_update: false,
      },
      baseUrl: buildConfig.BASE_URL,
      header: {
        Authorization: "Bearer " + localStorage.adminToken,
      },
    };
  },
  created() {
    this.getVersion("ios");
  },
  methods: {
    getVersion(type) {
      this.$http.get(`/api/version/${type}`).then((res) => {
        this[type] = res[type];
      });
    },
    submits(name) {
      const that = this;
      that.$refs[name].validate((val) => {
        if (!val) {
          that.$Message.error("输入有误，请检查！");
          return;
        }

        that.$http.put(`/api/version/${name}`, that[name]).then((res) => {
          if (res.code === 200) {
            that.$Message.success(res.msg);
          } else {
            that.$Message.error(res.msg);
          }
        });
      });
    },
    reset(name) {
      this[name] = this.initialData;
      this[name].type = name;
    },
    showName(name) {
      this.getVersion(name);
    },
  },
};
</script>

<style lang="scss" scoped>
.ivu-tabs .ivu-tabs-tabpane {
  padding: 20px;
}
</style>
